import { Popover } from "antd";
import { useEffect, useState } from "react";

interface ColumnClickHintProps {
  children: React.ReactNode;
  text: string;
}

export const ColumnClickHint: React.FC<ColumnClickHintProps> = ({
  children,
  text,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
    const timer = setTimeout(() => setOpen(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Popover content={text} open={open} placement="top">
      <div>{children}</div>
    </Popover>
  );
};
